import React from 'react';
import { ClerkProvider } from '@clerk/clerk-react';

interface ClerkWrapperProps {
  children: React.ReactNode;
  publishableKey: string;
}

export const ClerkWrapper: React.FC<ClerkWrapperProps> = ({ 
  children, 
  publishableKey 
}) => {
  // Only run on client side
  if (typeof window === 'undefined') {
    return null;
  }

  // Validate the publishable key format
  if (!publishableKey || !publishableKey.startsWith('pk_')) {
    console.error('Invalid Clerk publishable key:', publishableKey);
    return <div>Error: Invalid Clerk configuration</div>;
  }

  // Configure Clerk for cross-origin usage
  const clerkOptions = {
    publishableKey,
    appearance: {
      baseTheme: undefined,
      variables: {
        colorPrimary: '#000000',
      },
    },
    // Add cross-origin support
    allowedRedirectOrigins: ['*'],
    telemetry: false,
    experimental: {
      supportEmail: 'support@zynextechai.com'
    }
  };

  return (
    <ClerkProvider {...clerkOptions}>
      {children}
    </ClerkProvider>
  );
}; 